module.exports = __webpack_public_path__ + "static/img/kb-card-img-01@t.8302534.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-img-01@t.jpg
// module id = 698A
// module chunks = 0